import { animateToElementInContainer, xhrRequest } from '../../../../javascript/shared/helpers';
import { closeInlineForms, addFormHandlers } from '../../../../javascript/stimulusControllers/messages/messageHelpers';

export default class extends Controller {
  static targets = ['link'];

  connect() {
    this.data.get('openOnLoad') && this.openReply();
  }

  openReply(event) {
    event && event.preventDefault();
    const link = this.linkTarget;
    closeInlineForms();
    xhrRequest(this.data.get('formUrl'), 'get', {}).then(({ data }) => {
      const form = this.createNewMessageForm(data);
      link.closest('.messages--message-div').querySelector('.message--replies').appendChild(form);
      addFormHandlers(form);
      animateToElementInContainer({ container: this.parentMessage, destination: form })
      link.closest('.messages--message-div').querySelector('.messages--message-footer--component').style.display = 'none';
    });
  }

  //
  // INTERNAL USE
  //

  createNewMessageForm(html) {
    const form = document.createElement('div');
    form.className = "inline-msg-container reply-form-content";
    form.innerHTML = html;
    return form;
  }

  get parentMessage() {
    return this.element.closest(".messages--message-div")
  }
}



// WEBPACK FOOTER //
// ./app/components/messages/assets/javascript/message-reply-link-controller.js